import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Header } from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-luxe min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-6 pt-36 pb-24">
        <h1 className="font-display text-3xl text-[#F5F3EE] text-center">Mot de passe oublié</h1>
        {sent ? (
          <div data-testid="forgot-password-sent" className="mt-10 bg-[#141414] border border-white/10 p-8 text-center">
            <MailCheck className="w-10 h-10 text-[#D4AF37] mx-auto" />
            <p className="mt-6 text-sm text-[#B0B0B0] leading-relaxed">
              Si un compte existe avec cette adresse, un email de réinitialisation vient d'être
              envoyé. Pensez à vérifier vos spams. Le lien expire dans 1 heure.
            </p>
            <Link to="/connexion" data-testid="back-to-login-link" className="inline-block mt-8 text-sm underline text-[#D4AF37]">
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <>
            <p className="mt-3 text-sm text-[#8F8F8F] text-center">
              Saisissez votre email — nous vous enverrons un lien de réinitialisation
            </p>
            <form onSubmit={submit} className="mt-10 bg-[#141414] border border-white/10 p-8 space-y-5" data-testid="forgot-password-form">
              <div>
                <Label htmlFor="email" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Email</Label>
                <Input
                  id="email" type="email" data-testid="forgot-email-input" value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="jean@email.com" required
                  className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
                />
              </div>
              <button
                type="submit" data-testid="forgot-submit-button" disabled={loading}
                className="w-full bg-[#D4AF37] text-[#0A0A0A] font-semibold py-4 text-sm uppercase tracking-widest hover:bg-[#C9A227] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
              >
                {loading && <Loader2 className="w-4 h-4 animate-spin" />} Envoyer le lien
              </button>
              <p className="text-center text-sm text-[#8F8F8F]">
                <Link to="/connexion" data-testid="forgot-back-login" className="underline text-[#D4AF37]">
                  Retour à la connexion
                </Link>
              </p>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
